<template>
  <div v-show="show" class="steps">
    <div class="weui-mask"></div>
    <div class="steps-content">
      <slot></slot>
      <div @click="hide" class="icon-close"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'steps',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    step: {
      type: Number,
      default: 1
    }
  },
  methods: {
    hide() {
      this.$emit('update:show', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.weui-mask {
  position: fixed;
  z-index: 1000;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
}
.steps-content {
  position: fixed;
  z-index: 1001;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 562px;
  padding: 30px;
  background: #faf8dd;
  box-shadow: 0 0 0 12px #faf8dd;
  background-size: 100%;
  border-radius: 6px;
  border: 6px solid #f8e8cf;
  color: #353a4a;
  font-size: 28px;
  margin-top: -60px;
}
.icon-close {
  background: url('../img/icon-close.png') no-repeat;
  background-size: 100% 100%;
  width: 78px;
  height: 78px;
  position: absolute;
  left: 0;
  right: 0;
  bottom: -130px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/cs180824/components/steps.vue